/**
 * This file is part of Magestore POS Open Source.
 *
 * Magestore POS Open Source is free software: you can redistribute it
 * and/or modify it under the terms of the GNU General Public License
 * as published by the Free Software Foundation, either version 3
 * of the License, or (at your option) any later version.
 *
 * Magestore POS Open Source is distributed in the hope that it will
 * be useful, but WITHOUT ANY WARRANTY; without even the implied warranty
 * of MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.
 * See the GNU General Public License for more details.
 *
 * You should have received a copy of the GNU General Public License along
 * with Magestore POS Open Source. If not, see <https://www.gnu.org/licenses/>
 */
export { default as OmcUser } from './OmcUser';
export { default as OmcConfig } from './OmcConfig';
export { default as OmcProduct } from './OmcProduct';
export { default as OmcActionLog } from './OmcActionLog';
export { default as OmcLocation } from './OmcLocation';
export { default as OmcPayment } from './OmcPayment';
export { default as OmcShipping } from './OmcShipping';
export { default as OmcStock } from './OmcStock';
export { default as OmcOrder } from './OmcOrder';
export { default as OmcColorSwatch } from './OmcColorSwatch';
export { default as OmcCustomer } from './OmcCustomer';
export { default as OmcQuote } from './OmcQuote';
export { default as OmcCategory } from './OmcCategory';
export { default as OmcTaxRate } from './OmcTaxRate';
export { default as OmcTaxRule } from './OmcTaxRule';
export { default as OmcCatalogRuleProductPrice } from './OmcCatalogRuleProductPrice';


// WEBPACK FOOTER //
// ./src/data/omc/index.js